import styled, { css } from 'styled-components';
import { animation } from './helpers/variables';

export const Icon = styled.div`
  width: 44px;
  height: 44px;
  background-image: url(${props => (props.image ? props.image : '/images/icons/arrow.svg')});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 14px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity ${animation.transitionTime} ${animation.easing};

  ${props =>
    props.right &&
    css`
      transform: rotateZ(-90deg);
    `} ${props =>
    props.left &&
    css`
      transform: rotateZ(90deg);
    `}
 
  &:hover {
    opacity: 1;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/Icon.js